module.exports = __webpack_public_path__ + "img/img9.a0b9a801.png";